import React from 'react'
import { connect } from 'react-redux'

import { getShipImages, getShipVideo } from '../../reducers/ships'
import { getFeaturedItineraryImage } from '../../reducers/packageDetails'
import { getDestinationDetails } from '../../reducers/destinations'
import { getSingleBrandDetails } from '../../reducers/brands'

import EQuotePackageCarousel from '../carousel/EQuotePackageCarousel'

import { filterImagesByFileName } from '../../utils/filterImagesByFileName'

import '../../styles/scss/components/equote-preview-package-ship-image-carousel.scss'

const EQuotePackageHeroSlider = props => {
  return (
    <div className="equote-preview-package-images">
      {props.slides && (
        <EQuotePackageCarousel
          slides={props.slides}
          autoplay
          shouldSendGaEvent
          gaText="bannerImage"
          gaNextArrowText="hero-slider-next"
          gaPrevArrowText="hero-slider-prev"
        />
      )}
    </div>
  )
}

const renderSlides = (destinationImage, shipImages, brandImages) => {
  const numberOfShipSlides = brandImages && brandImages.length ? 4 : 5
  const images = destinationImage ? [destinationImage] : []
  shipImages.slice(0, numberOfShipSlides).forEach(img => images.push(img))

  if (brandImages && brandImages.length) {
    images.push(brandImages[0])
  }
  return filterImagesByFileName(images, 'details-hero')
}

const mapStateToProps = (state, ownProps) => {
  const shipImages = getShipImages(state, 5)
  const shipVideo = getShipVideo(state)

  const brandDetails = getSingleBrandDetails(state)
  const brandImage = brandDetails ? brandDetails.image : []

  const featuredPortImage = getFeaturedItineraryImage(state)
  const destinationDetails = getDestinationDetails(state)

  let featurePortSlide

  if (featuredPortImage) {
    const filteredPortImage = filterImagesByFileName(
      featuredPortImage.highlight.image,
      'details-hero'
    )

    featurePortSlide = {
      file: filteredPortImage[0].displayImage,
      marketing_title: featuredPortImage.highlight.image[0].marketing_title,
      marketing_subtitle:
        featuredPortImage.highlight.image[0].marketing_subtitle
    }
  }

  let brandDestinationImage
  if (
    brandDetails &&
    brandDetails.brand_code &&
    destinationDetails &&
    destinationDetails[`image_${brandDetails.brand_code.toLowerCase()}`]
  ) {
    brandDestinationImage =
      destinationDetails[`image_${brandDetails.brand_code.toLowerCase()}`]
  }
  const destinationImage = brandDestinationImage
    ? brandDestinationImage[0]
    : destinationDetails &&
      destinationDetails.image &&
      destinationDetails.image.length
    ? destinationDetails.image[0]
    : null

  const slideToFeature = featurePortSlide ? featurePortSlide : destinationImage
  const slides = state.brands.items
    ? renderSlides(slideToFeature, shipImages, brandImage)
    : []

  return {
    slides: shipVideo
      ? [
          {
            type: 'video',
            file: shipVideo
          },
          ...slides
        ]
      : slides,
    shouldHideText: ownProps.shouldHideText
  }
}

export default connect(mapStateToProps)(EQuotePackageHeroSlider)
